// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2QitM","choiceBoxes":"toolbarselects_choiceBoxes__KlzzF","simpleField":"toolbarselects_simpleField__1FM3I"};